<template>
  <Main>
    <div>
      <BackButton text="Back to Project" :route="$routes.project(projectId)" />
      <v-container max-width="1400">
        <div class="text-center mb-10">
          <h2 class="mb-3">
            {{ psi.id }}. {{ StringManipulation.methods.clearAndCapitalize(psi.name) }}
          </h2>
          <h3 class="text-grey-darken-2 font-weight-light">Functional Unit: <b class="font-weight-bold">{{
              psiType?.functional_unit ?? '-'
            }}</b></h3>
        </div>

        <DividerWithText class="mb-4 mt-15" text="General PSI Information" color="#abc" text-color="#479" />
        <v-table hover>
          <thead>
          <tr>
            <th v-for="item in tableFields" :key="item">
              {{ StringManipulation.methods.clearAndCapitalize(item) }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td v-for="item in tableFields" :key="item">
              {{ props.psi[item] }}
            </td>
          </tr>
          </tbody>
        </v-table>

        <DividerWithText class="mt-10 mb-4" text="Margins (Relative)" color="#abc" text-color="#479" />
        <v-data-table
            hover
            :items="scale"
            :headers="headers2"
            class="elevation-1"
            item-value="scale"
            :hide-default-footer="true"
        >
          <template v-slot:item="{ item }">
            <tr :style="{ backgroundColor: getColor(item.scale) }">
              <td>{{ item.scale }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </template>
        </v-data-table>

        <v-row class="mt-15 text-center">
          <v-col>
            <v-btn class="px-lg-16"
                   variant="flat"
                   text="Edit"
                   prepend-icon="mr-3 fas fa-pen"
                   color="blue-darken-4"
                   @click="router.get($routes.edit_project_psi(projectId, props.psi.id))"
            />
          </v-col>
        </v-row>

      </v-container>
    </div>
  </Main>
</template>

<script setup>
import Main from "../../Layouts/Main.vue";
import StringManipulation from "../../Mixins/StringManipulation";
import MarginsFunctions from "../../Mixins/MarginsFunctions";
import { computed } from "vue";
import * as $routes from "@/packs/routes";
import BackButton from "@/Shared/BackButton.vue";
import {router} from "@inertiajs/vue3";
import DividerWithText from "@/Shared/DividerWithText.vue";

const props = defineProps({
  notice: {
    type: String,
    required: false,
    default: null
  },
  projectId: {
    type: Number,
    required: true,
  },
  psiType: {
    type: Object,
    required: true
  },
  psi: {
    type: Object,
    required: true,
  },
});

const scale = computed(() => {
  return MarginsFunctions.methods.showPageMargins([
    props.psi["m0"],
    props.psi["m1"],
    props.psi["m2"],
    props.psi["m3"],
  ]);
});

const headers2 = [
  { title: "Scale", key: "scale" },
  { title: "Value", key: "value" },
];

const tableFields = ["value", "call_impact", "target_value"];

// TODO: Move this in another file and reuse
// I am placing it here now in order not to mess up any code that other developers write
function getColor(value) {
  if (value === "Failed") return "rgba(227,129,129,0.73)";
  else if (value === "Underachieved") return "rgba(255,186,54,0.67)";
  else if (value === "Achieved") return "#ece52eaa";
  else if (value === "Overachieved") return "rgba(213,255,152,0.67)";
  else return "rgba(147,209,147,0.73)";
}
</script>

<style scoped>
a:hover {
  background-color: #4391b9;
  border-radius: 2px;
}
thead {
  background: #2b28d2;
  color: #fff;
}
tbody :nth-child(odd) {
  background-color: #eeeeee;
}
::v-deep thead tr th {
  background-color: #0d479c !important;
  font-weight: bold;
}
::v-deep thead tr {
  color: #fff !important;
}
</style>
